import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import styled from "@emotion/styled";
import { Ui } from "@silvertours/front-shared";
import { MapControl } from "@vis.gl/react-google-maps";
export var Wrapper = /*#__PURE__*/ styled("div", {
    target: "e7wmg4d0"
})("width:100%;height:25rem;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{height:29.5rem;}", function(param) {
    var theme = param.theme;
    return theme.mq("xl");
}, "{height:39rem;}");
export var StationsListContainer = /*#__PURE__*/ styled("div", {
    target: "e7wmg4d1"
})("width:", function(props) {
    return props.width;
}, "px;");
export var StationsList = /*#__PURE__*/ styled("div", {
    target: "e7wmg4d2"
})("margin:", function(props) {
    return props.theme.spacing[30];
}, ";height:77px;width:100%;display:flex;flex-direction:row;gap:", function(props) {
    return props.theme.spacing[30];
}, ";overflow-x:auto;white-space:nowrap;padding-right:", function(props) {
    return props.theme.spacing[30];
}, ";");
export var InfoBox = /*#__PURE__*/ styled("div", {
    target: "e7wmg4d3"
})("height:100%;width:311px;min-width:311px;background-color:white;border-radius:", function(props) {
    return props.theme.borderRadius.md;
}, ";border:2px solid\n    ", function(props) {
    return props.selected ? props.theme.color.primary70 : props.theme.color.natural50;
}, ";display:flex;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;&:last-of-type{margin-right:", function(props) {
    return props.theme.spacing[30];
}, ";}");
export var StyledMapControl = /*#__PURE__*/ styled(MapControl, {
    target: "e7wmg4d4"
})("width:100%;");
var WaveSVG = function() {
    return /*#__PURE__*/ _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "43",
        height: "76",
        viewBox: "0 0 43 76",
        fill: "none",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M40.2858 125C5.06596 60.6061 57.8958 53.9773 37.7701 0H-1.5V125H40.2858Z",
            fill: "#F3F3F3"
        })
    });
};
export var Wave = /*#__PURE__*/ styled(WaveSVG, {
    target: "e7wmg4d5"
})("overflow:hidden;");
export var IconContainer = /*#__PURE__*/ styled("div", {
    target: "e7wmg4d6"
})("min-width:44px;border-top-left-radius:", function(props) {
    return props.theme.borderRadius.md;
}, ";border-bottom-left-radius:", function(props) {
    return props.theme.borderRadius.md;
}, ";overflow:hidden;");
export var TextContainer = /*#__PURE__*/ styled("div", {
    target: "e7wmg4d7"
})("font-size:", function(props) {
    return props.theme.fontSize.sm.size;
}, ";padding:", function(props) {
    return props.theme.spacing[40];
}, ";padding-right:", function(props) {
    return props.closable ? props.theme.spacing[60] : props.theme.spacing[40];
}, ";display:flex;flex-direction:column;justify-content:center;gap:", function(props) {
    return props.theme.spacing[10];
}, ";overflow:hidden;");
export var StationIcon = /*#__PURE__*/ styled("div", {
    target: "e7wmg4d8"
})("position:relative;top:-65px;padding-left:14px;");
export var StationText = /*#__PURE__*/ styled(Ui.Typography, {
    target: "e7wmg4d9"
})("text-overflow:ellipsis;overflow:hidden;");
